/**全局变量*/

// 上传URL
//const uploadURL = 'http://cdn.deephealth.net:9333/submit'

//导出URL
// const exportURL = 'http://admin.deephealth.net'
const exportURL = 'https://devpatient.deephealth.net/drug';    // 测试环境
// const exportURL = 'https://devscm.deephealth.net/drug';    // 开发环境
// const exportURL = 'https://tdrugapi.deephealth.net';    // 正式环境

let isTransferFlag = true //true药厂药师  false手填开药药师

export default {
  // uploadURL,
  exportURL,
  isTransferFlag
}



// WEBPACK FOOTER //
// ./src/api/global/globalVariable.js